import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { dealWithOthersName } from '@op/utils/languageValue';
import './index.scss';

export default function LanguageSubtitle(props: any) {
  const { filter, statsDetailChartsData } = props;
  const { formatMessage } = useIntl();
  const { type } = statsDetailChartsData || {};

  const subtitle = useMemo(() => {
    const { language, reviews_rating } = filter || {};
    if (!language?.length || !reviews_rating?.length) return '';

    const commentText = reviews_rating[0] === 'positive' ? `${formatMessage({ id: 'Recommended' })}` : `${formatMessage({ id: 'Not Recommended' })}`;
    const languageText = dealWithOthersName(language[0], 'language');

    return formatMessage(
      { id: `Selected: {language} - {comment}` },
      { language: languageText, comment: commentText },
    );

  }, [filter, formatMessage]);

  return (
    <>
      {
        type === 'stacked-common-bar' && (
          <div className='dbo-language-subtitle'>
            <span>{subtitle}</span>
          </div>
        )
      }

    </>
  );
}